
                <div class="body main-container">
                    <div class="form-group genaration-dropdown">
                        <!-- <div *ngIf="Demo"> -->
    
                            <div class="grid-container">
                                <div class="grid-item">
                                    <div class="card">
                                        <h2>Basic Membership</h2>
                                        <p class="price">$490</p>
                                        <p>Please Upgrade 1 year Basic membership to access basic reports only</p>
                                        <p><button>
                                                <a target="_blank" href="https://shop.embla.no/home">Upgrade Now</a>
                                            </button></p>
                                    </div>
                                </div>
    
                                <div class="grid-item">
                                    <div class="card">
                                        <h2>Premium Membership</h2>
                                        <p class="price">$890</p>
                                        <p>Please Upgrade 1 year premium membership to access premium reports</p>
                                        <p><button>
                                                <a target="_blank" href="https://shop.embla.no/home">Upgrade Now</a>
                                            </button></p>
                                    </div>
                                </div>
                            </div>
                        <!-- </div> -->
    
                     
                    </div>
    
    
    
                  
                </div>
    
    
    
          